import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-permission-confirmdialog',
  templateUrl: './permission-confirmdialog.component.html',
  styleUrls: ['./permission-confirmdialog.component.css']
})
export class PermissionConfirmdialogComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<PermissionConfirmdialogComponent>) { }

  ngOnInit(): void {
  }

  ok = () => {
    this.dialogRef.close(true);
  }

}
